/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { ExpenseCategory } from './';
import {
    ExpenseCategoryFromJSON,
    ExpenseCategoryFromJSONTyped,
    ExpenseCategoryToJSON,
} from './';
import type { ExpenseStatus } from './';
import {
    ExpenseStatusFromJSON,
    ExpenseStatusFromJSONTyped,
    ExpenseStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseResource
 */
export interface ExpenseResource {
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    expenseId: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    missionId: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseResource
     */
    submissionDate: Date;
    /**
     * 
     * @type {ExpenseCategory}
     * @memberof ExpenseResource
     */
    category: ExpenseCategory;
    /**
     * 
     * @type {ExpenseStatus}
     * @memberof ExpenseResource
     */
    status: ExpenseStatus;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    receiptId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    receiptName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseResource
     */
    receiptUploadDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    receiptDownloadUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseResource
     */
    purchaseDate: Date;
    /**
     * 
     * @type {Currency}
     * @memberof ExpenseResource
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    amountWithoutTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    amountWithTaxes?: number;
    /**
     * 125
     * @type {number}
     * @memberof ExpenseResource
     */
    distance?: number;
    /**
     * 1.25
     * @type {number}
     * @memberof ExpenseResource
     */
    distanceRate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExpenseResource
     */
    vatDeductible: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    vatDeductibleRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    freelancerVatPercent?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    amountWithTaxesMinusVatDeductible: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseResource
     */
    amountTotal: number;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    supplier: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    approvalBlockedMessage?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseResource
     */
    approvalBlockedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    expenseProjectCorrelationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseResource
     */
    batchId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseResource
     */
    batchCreatedDate?: Date;
}

/**
 * Check if a given object implements the ExpenseResource interface.
 */
export function instanceOfExpenseResource(value: object): value is ExpenseResource {
    if (!('expenseId' in value) || value['expenseId'] === undefined) return false;
    if (!('missionId' in value) || value['missionId'] === undefined) return false;
    if (!('submissionDate' in value) || value['submissionDate'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('purchaseDate' in value) || value['purchaseDate'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('vatDeductible' in value) || value['vatDeductible'] === undefined) return false;
    if (!('amountWithTaxesMinusVatDeductible' in value) || value['amountWithTaxesMinusVatDeductible'] === undefined) return false;
    if (!('amountTotal' in value) || value['amountTotal'] === undefined) return false;
    if (!('supplier' in value) || value['supplier'] === undefined) return false;
    return true;
}

export function ExpenseResourceFromJSON(json: any): ExpenseResource {
    return ExpenseResourceFromJSONTyped(json, false);
}

export function ExpenseResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseResource {
    if (json == null) {
        return json;
    }
    return {
        
        'expenseId': json['expenseId'],
        'missionId': json['missionId'],
        'submissionDate': (new Date(json['submissionDate'])),
        'category': ExpenseCategoryFromJSON(json['category']),
        'status': ExpenseStatusFromJSON(json['status']),
        'receiptId': json['receiptId'] == null ? undefined : json['receiptId'],
        'receiptName': json['receiptName'] == null ? undefined : json['receiptName'],
        'receiptUploadDate': json['receiptUploadDate'] == null ? undefined : (new Date(json['receiptUploadDate'])),
        'receiptDownloadUrl': json['receiptDownloadUrl'] == null ? undefined : json['receiptDownloadUrl'],
        'purchaseDate': (new Date(json['purchaseDate'])),
        'currency': CurrencyFromJSON(json['currency']),
        'amountWithoutTaxes': json['amountWithoutTaxes'] == null ? undefined : json['amountWithoutTaxes'],
        'amountWithTaxes': json['amountWithTaxes'] == null ? undefined : json['amountWithTaxes'],
        'distance': json['distance'] == null ? undefined : json['distance'],
        'distanceRate': json['distanceRate'] == null ? undefined : json['distanceRate'],
        'vatDeductible': json['vatDeductible'],
        'vatDeductibleRate': json['vatDeductibleRate'] == null ? undefined : json['vatDeductibleRate'],
        'freelancerVatPercent': json['freelancerVatPercent'] == null ? undefined : json['freelancerVatPercent'],
        'amountWithTaxesMinusVatDeductible': json['amountWithTaxesMinusVatDeductible'],
        'amountTotal': json['amountTotal'],
        'supplier': json['supplier'],
        'description': json['description'] == null ? undefined : json['description'],
        'approvalBlockedMessage': json['approvalBlockedMessage'] == null ? undefined : json['approvalBlockedMessage'],
        'approvalBlockedDate': json['approvalBlockedDate'] == null ? undefined : (new Date(json['approvalBlockedDate'])),
        'expenseProjectCorrelationId': json['expenseProjectCorrelationId'] == null ? undefined : json['expenseProjectCorrelationId'],
        'batchId': json['batchId'] == null ? undefined : json['batchId'],
        'batchCreatedDate': json['batchCreatedDate'] == null ? undefined : (new Date(json['batchCreatedDate'])),
    };
}

export function ExpenseResourceToJSON(value?: ExpenseResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expenseId': value['expenseId'],
        'missionId': value['missionId'],
        'submissionDate': ((value['submissionDate']).toISOString()),
        'category': ExpenseCategoryToJSON(value['category']),
        'status': ExpenseStatusToJSON(value['status']),
        'receiptId': value['receiptId'],
        'receiptName': value['receiptName'],
        'receiptUploadDate': value['receiptUploadDate'] == null ? undefined : ((value['receiptUploadDate']).toISOString()),
        'receiptDownloadUrl': value['receiptDownloadUrl'],
        'purchaseDate': ((value['purchaseDate']).toISOString().substring(0,10)),
        'currency': CurrencyToJSON(value['currency']),
        'amountWithoutTaxes': value['amountWithoutTaxes'],
        'amountWithTaxes': value['amountWithTaxes'],
        'distance': value['distance'],
        'distanceRate': value['distanceRate'],
        'vatDeductible': value['vatDeductible'],
        'vatDeductibleRate': value['vatDeductibleRate'],
        'freelancerVatPercent': value['freelancerVatPercent'],
        'amountWithTaxesMinusVatDeductible': value['amountWithTaxesMinusVatDeductible'],
        'amountTotal': value['amountTotal'],
        'supplier': value['supplier'],
        'description': value['description'],
        'approvalBlockedMessage': value['approvalBlockedMessage'],
        'approvalBlockedDate': value['approvalBlockedDate'] == null ? undefined : ((value['approvalBlockedDate']).toISOString()),
        'expenseProjectCorrelationId': value['expenseProjectCorrelationId'],
        'batchId': value['batchId'],
        'batchCreatedDate': value['batchCreatedDate'] == null ? undefined : ((value['batchCreatedDate']).toISOString()),
    };
}

